import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material';
import React, { forwardRef } from 'react';
import { InputSize } from '../../model';
import { SxProps } from '../../utils';

type NativeInputProps = Omit<React.ComponentPropsWithoutRef<'input'>, 'size'>;

interface TextFieldPropsBase extends NativeInputProps {
  /**
   * Optional: The size determines how compact the text input is
   * @default medium
   */
  size?: InputSize;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps;
}

export type TextFieldProps = TextFieldPropsBase &
  Pick<
    MuiTextFieldProps,
    | 'id'
    | 'name'
    | 'value'
    | 'onChange'
    | 'onBlur'
    | 'error'
    | 'helperText'
    | 'label'
    | 'required'
    | 'disabled'
    | 'fullWidth'
    | 'inputProps'
    | 'InputProps'
    | 'InputLabelProps'
    | 'inputRef'
    | 'multiline'
    | 'rows'
    | 'minRows'
    | 'maxRows'
  >;

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(function TextField(
  { children, size = 'medium', ...props },
  ref
) {
  return (
    <MuiTextField {...props} variant="outlined" color="primary" ref={ref} size={size}>
      {children}
    </MuiTextField>
  );
});
